/* eslint-disable complexity */
import React, {useMemo, useState} from "react";
import styles from "./styles.css";
import { trackDesktopCustomEventsAU } from "../../../tracking";
import { AU_DESKTOP_EVENTS } from "../../../tracking/au.desktop-events";
import { PropTypes } from "prop-types";
import { PAGE_SOURCE } from "../../../constants/app-constants.js";
import { yieldToMain } from "../../../utils/helpers/yield-to-main.js";
import LazyImage from "../../shared/lazy-image/index.js";

const InspectionDataList = ({
    contentData = {},
    pageSource = PAGE_SOURCE.THREE_HUNDERED_POINT_INSPECTION,
    trackCustomEvent,
    hideSearch = false
}) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [fitlerValue, setFilterValue] = useState("");
    const {items: tabDetails, rwcInspectionValues, threeHundredPointChecklist, inspectionCarImage } = contentData || {};

    const getCategoryList = (index) => threeHundredPointChecklist.categories[index];

    const isRWCPage = useMemo(() => {
        return pageSource === PAGE_SOURCE.RWC;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pageSource]);

    const trackEvent = (action = "THREE_HUNDRED_CATEGORY", eventLabel) => {
        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS[action], {eventLabel});
        if (isRWCPage) trackCustomEvent(eventLabel);
    };

    const handleTab = async (index) => {
        setCurrentIndex(index);
        await yieldToMain();
        trackEvent("THREE_HUNDRED_CATEGORY", getCategoryList(currentIndex).title);
    };

    const handleBlur = () => {
        trackEvent("THREE_HUNDRED_SEARCH", fitlerValue);
    };

    const handleFilter = (e) => {
        setFilterValue(e.target.value.toLocaleLowerCase());
    };

    const getFilteredData = () => {
        if (isRWCPage) {
            const currentCategoryKey = tabDetails[currentIndex]?.key;
            return rwcInspectionValues[currentCategoryKey];
        } else {
            return getCategoryList(currentIndex).categoryDetailsList
                .filter(item => item.title.toLocaleLowerCase().indexOf(fitlerValue) >= 0);
        }
    };

    const filteredData = useMemo(() => {
        return getFilteredData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isRWCPage, currentIndex]);

    const renderPoints = () => {
        if (isRWCPage) {
            return (
                <div styleName={"styles.gridContainer"}>
                    {filteredData.map((item, index) =>
                        (<div key={item.title + index} styleName={"styles.gridItem"}>
                            <LazyImage src={item?.image} alt="tick"/>
                            <p styleName={"styles.gridItemList"}>{item?.text}</p>
                        </div>)
                    )}
                </div>
            );
        } else {
            return  (<ul styleName={"styles.listPointWrapper"}>
                {filteredData.map((item, index) =>
                    <li key={item.title + index}>{item.title}</li>
                )}
            </ul>);
        }
    };
    return (
        <div styleName={"styles.inspectionWrapper"}>
            <ul styleName={"styles.inspectionPointTabs"}>
                {tabDetails.map((tab, index) =>
                    (<li styleName={index === currentIndex ? "styles.active" : ""}
                        key={tab.title + index}
                        onClick={() => handleTab(index)}>
                        <span styleName={"styles.thumbImage"}><LazyImage src={tab.tabImage} alt={tab.title} /></span>
                        <h4>{tab.title}</h4>
                    </li>)

                )}
            </ul>
            <div styleName={"styles.tabContainer"}>
                <h3 styleName={"styles.PointTitle"}>{getCategoryList(currentIndex).title}</h3>
                <p styleName={"styles.PointSubTitle"}>{filteredData?.length} points inspected</p>
                <div className="row" styleName={isRWCPage && "styles.pointContainer"}>
                    <div className="col-5">
                        { !hideSearch &&
                        <input className="form-control"
                            styleName={"styles.inputSearch"}
                            type="search"
                            placeholder="Search for any part"
                            onChange={handleFilter}
                            onBlur={handleBlur}/>
                        }
                        {filteredData && filteredData.length > 0 ? renderPoints() :  <p styleName="styles.notFoundText">{"No Result Found"}</p>}
                    </div>
                    <div className="col-6">
                        <div styleName={`styles.imageWrap styles.${getCategoryList(currentIndex).ripplePointStyle}`}>
                            <span styleName={"styles.ripple"} />
                            <LazyImage src={inspectionCarImage} alt="Inspection Report" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

InspectionDataList.propTypes = {
    pageSource: PropTypes.string,
    contentData: PropTypes.object,
    trackCustomEvent: PropTypes.func,
    hideSearch: PropTypes.bool
};

export default InspectionDataList;

